import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Organization} from '../../types/organization/organization';
import {OrganizationRestService} from '../../services/oganization/organization-rest.service';
import {UntypedFormGroup} from '@angular/forms';
import {SystemType} from '../../types/common/system-type';

@Component({
  selector: 'wsd-select-organization-ac',
  templateUrl: './select-organization-ac.component.html',
  styleUrls: ['./select-organization-ac.component.css']
})
export class SelectOrganizationAcComponent implements OnInit {

  @Input()
  parentForm: UntypedFormGroup;

  @Input()
  label: string = 'SELECT_ORGANIZATION.LABEL';

  @Input()
  controlName: string = 'organization';

  @Input()
  placeholder: string = 'SELECT_ORGANIZATION.PLACEHOLDER';

  @Input()
  showLabel: boolean = true;

  @Input()
  showPlaceholder: boolean = true;

  @Input()
  count: number = 10;

  @Input()
  excludeOrganizations: number[] = [];

  @Output()
  onSelect: EventEmitter<Organization> = new EventEmitter();

  organizations: Organization[] = [];

  allOrganizations: Organization[] = [];

  constructor(private organizationService: OrganizationRestService) {
  }

  ngOnInit() {
    this.initOrganizations();
  }

  private initOrganizations() {
    this.organizationService.getAllOrganizations(SystemType.DIRECTORY).subscribe(
      (organizations: Organization[]) => {
        this.allOrganizations = organizations;
        if (this.allOrganizations.length === 1) {
          this.parentForm.get(this.controlName).setValue(this.allOrganizations[0]);
          this.onSelect.emit(this.allOrganizations[0]);
        }
      }
    );
  }

  filterOrganizations(event) {
    this.filterBy(event.query);
  }

  onSelectValue(event) {
    this.onSelect.emit(event);
  }

  private filterBy(query: string) {
    this.organizations = [];
    for (const organization of this.allOrganizations) {
      if (organization.name.toLowerCase().indexOf(query.toLowerCase()) > -1
        && this.excludeOrganizations.indexOf(organization.id) === -1) {
        this.organizations.push(organization);
      }
    }
  }

}
